import { CheckInput } from "../../../../../../common/Input";
import { Select } from "../../../../../../common/Select";
import SectionBadge from "../../ui/SectionBadge";

const ScheduleTab = ({ form, set, options, editable, errors, accessRules }) => {
  const daysOfWeek = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

  // MODIFIED: Logic to handle comma-separated string as multiple checkboxes
  const handleRestDayToggle = (day, isChecked) => {
    let selectedDays = form.restDay ? form.restDay.split(',').filter(x => x.trim() !== "") : [];

    if (isChecked) {
      if (!selectedDays.includes(day)) selectedDays.push(day);
    } else {
      selectedDays = selectedDays.filter(d => d !== day);
    }

    // Sort them so they always appear in Monday-Sunday order regardless of click order
    const sortedDays = daysOfWeek.filter(d => selectedDays.includes(d));
    set('restDay', sortedDays.join(','));
  };

  const isDaySelected = (day) => {
    return form.restDay?.split(',').includes(day);
  };

  return (
    <div className="space-y-6">
      {accessRules?.allowRestDay && (
        <div className="bg-gray-50 p-6 rounded-xl border border-gray-200">
          <SectionBadge label="New Employee Restday/s" editable={editable} />
          <div className="space-y-4">
            {/* MODIFIED: Rest Day Selection from Dropdown to Multi-Checkbox */}
            <div>
              <label className="mb-1.5 block text-sm font-medium text-gray-600">
                Rest Day(s): <span className="ml-1 text-red-500">*</span>
              </label>
              <div className={`grid grid-cols-1 sm:grid-cols-3 gap-1 p-3 border rounded-lg bg-white ${errors.restDay ? 'border-red-500' : 'border-gray-300'}`}>
                {daysOfWeek.map(day => (
                  <CheckInput
                    key={day}
                    name={day}
                    value={isDaySelected(day)}
                    onChange={(checked) => handleRestDayToggle(day, checked)}
                    isEditMode={editable}
                  />
                ))}
              </div>
              {errors.restDay && <p className="mt-1 text-xs text-red-500">{errors.restDay}</p>}
            </div>
          </div>
        </div>
      )}
      
      {!form?.isOnLeave && accessRules?.allowShiftSchedule && (
        <div className="bg-gray-50 p-6 rounded-xl border border-gray-200">
          <SectionBadge label="New Employee Schedule" editable={editable} />
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-10 gap-y-4">
            <div className="space-y-4">
              <Select
                label="Shift Schedule:"
                options={options.shiftSchedules}
                value={form.shiftScheduleId}
                onChange={e => set('shiftScheduleId', e.target.value)}
                disabled={!editable}
                isRequired={true}
                error={!!errors.shiftScheduleId}
                errorMessage={errors.shiftScheduleId}
              />
            </div>
          </div>
        </div>
      )}

    </div>
  );
}

export default ScheduleTab;